import moment from 'moment-timezone'
import i18n from 'i18next';
import 'moment/locale/fr';

const FULL_DATE = 'lll z'

export const full = (date, tz = null) => {
  moment.locale((i18n.resolvedLanguage === 'fr') ? i18n.resolvedLanguage : 'en');
  if (tz) {
    return moment(date).tz(tz).format(FULL_DATE)
  } else {
    return moment(date).format(FULL_DATE)
  }
}

export const date = date => {
  moment.locale((i18n.resolvedLanguage === 'fr') ? i18n.resolvedLanguage : 'en');
  return moment(date).format('YYYY-MM-DD')
}

export const formatDate = (date, format, lang) => {
  return moment(date).locale(lang).format(format);
};
